import {ButtonPattern} from '@constellation/core';
import {memo} from 'react';
import {
  JOURNEY_EVENT,
  LINK_VALUE,
  TAGGING_FIELDS,
} from '../../../../../enums/tagging/index.js';
import {getPsrLabel} from '../../../../../utils/index.js';
import {QuoteSummaryButtons} from '../../../../common/Analytics/Tagging/index.js';

const handleReturnToAccountClick = () =>
  window.open(
    'https://www.lloydsbank.com/business/take-payments-with-cardnet.html',
    '_self'
  );

const ReturnButton = memo(() => (
  <ButtonPattern marginBottom='none' marginTop='07'>
    <QuoteSummaryButtons
      aria-label={getPsrLabel('cardPaymentServicesDetails.returnSrText')}
      eventAction={JOURNEY_EVENT.PAGE_SUBMIT}
      fieldName={TAGGING_FIELDS.RETURN_TO_CARDNET}
      journeyEvent={JOURNEY_EVENT.INTERNAL_CLICK}
      linkValue={LINK_VALUE.returntocardnet}
      taggingLabel={TAGGING_FIELDS.RETURN_TO_CARDNET}
      variation='secondary'
      onClick={handleReturnToAccountClick}
    >
      {getPsrLabel('cardPaymentServicesDetails.return')}
    </QuoteSummaryButtons>
  </ButtonPattern>
));

export default ReturnButton;
